export const industryOptions = [
  { label: 'Logistics', value: 'LOGISTICS' },
  { label: 'Enterprise SaaS', value: 'SAAS_ENTERPRISE' },
  { label: 'Fintech', value: 'FINANCIAL_SERVICES_FINTECH' },
  { label: 'Gaming', value: 'GAMING' },
  { label: 'RetailTech', value: 'RETAILTECH' },
  { label: 'HealthTech', value: 'HEALTHTECH' },
  { label: 'Consumer Brands', value: 'CONSUMER_BRANDS' },
  { label: 'Services', value: 'SERVICES' },
  { label: 'EdTech', value: 'EDTECH' },
  { label: 'Social Entertainment', value: 'SOCIAL_ENTERTAINMENT' },
  { label: 'AgriTech', value: 'AGRITECH' },
  { label: 'Travel & Hospitality', value: 'TRAVEL_AND_HOSPITALITY' },
  { label: 'AI', value: 'AI' },
  { label: 'EV/Mobility', value: 'EV_MOBILITY' },
  { label: 'E-Commerce', value: 'ECOMMERCE' },
  { label: 'DeepTech', value: 'DEEPTECH' },
  { label: 'PropTech', value: 'PROPTECH' },
  { label: 'Marketplace/Platform', value: 'MARKETPLACE_PLATFORM' },
  { label: 'CleanTech', value: 'CLEANTECH' },
  { label: 'F&B', value: 'F_AND_B' },
  { label: 'Other', value: 'OTHER' },
];
